import { useEffect, useState } from "react";
import { Loader2, Download } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { api, dateLabel, formatApiError, formatIDR } from "../lib/api";

export function ProofDialog({ paymentId, onClose }) {
  const [payment, setPayment] = useState(null);
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!paymentId) return;
    let url;
    setPayment(null);
    setBlobUrl(null);
    setError("");
    Promise.all([api.get(`/payments/${paymentId}`), api.get(`/payments/${paymentId}/proof`, { responseType: "blob" })])
      .then(([p, f]) => {
        setPayment(p.data);
        url = URL.createObjectURL(f.data);
        setBlobUrl(url);
      })
      .catch((e) => setError(formatApiError(e)));
    return () => url && URL.revokeObjectURL(url);
  }, [paymentId]);

  const isPdf = payment?.proof_content_type === "application/pdf";

  return (
    <Dialog open={!!paymentId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg max-h-[92vh] overflow-y-auto" data-testid="proof-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Bukti Pembayaran</DialogTitle>
          <DialogDescription>Screenshot transfer bank dari admin.</DialogDescription>
        </DialogHeader>
        {error && <p className="text-sm text-red-600" data-testid="proof-error">{error}</p>}
        {!payment && !error && <div className="py-10 grid place-items-center"><Loader2 className="h-6 w-6 animate-spin text-emerald-600" /></div>}
        {payment && (
          <div className="space-y-4">
            <div className="rounded-xl bg-emerald-50 border border-emerald-100 p-4 text-sm grid grid-cols-2 gap-y-1">
              <span className="text-slate-500">Driver</span><span className="text-right font-medium">{payment.driver_name}</span>
              <span className="text-slate-500">Bulan</span><span className="text-right">{payment.month}</span>
              <span className="text-slate-500">Jumlah Trip</span><span className="text-right font-num">{payment.trip_ids.length}</span>
              <span className="text-slate-500">Dibayar</span><span className="text-right">{dateLabel(payment.created_at)}</span>
              <span className="text-slate-500">Total</span><span className="text-right font-num font-bold text-emerald-700" data-testid="proof-amount">{formatIDR(payment.amount)}</span>
            </div>
            {payment.note && <p className="text-sm text-slate-600">Catatan: {payment.note}</p>}
            {blobUrl && (isPdf ? (
              <iframe title="bukti" src={blobUrl} className="w-full h-96 rounded-lg border" />
            ) : (
              <img src={blobUrl} alt="Bukti transfer" className="w-full rounded-lg border object-contain max-h-[60vh]" data-testid="proof-image" />
            ))}
            {blobUrl && (
              <a href={blobUrl} download={payment.proof_filename} className="inline-flex items-center gap-2 text-sm font-semibold text-emerald-700 hover:underline" data-testid="proof-download">
                <Download className="h-4 w-4" /> Unduh file
              </a>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
